import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FieldType, FieldTypeConfig, FormlyModule } from '@ngx-formly/core';

@Component({
  selector: 'app-formly-slider',
  standalone: true,
  imports: [FormlyModule, FormsModule, ReactiveFormsModule, CommonModule],
  styleUrls: ['slider.type.scss'],
  template: `
    <div class="slidecontainer">
      <input
        #slider
        type="range"
        [formControl]="formControl"
        [formlyAttributes]="field"
        [class.is-invalid]="showError"
        [step]="(field.props.max - field.props.min) / 100"
      />
      <span>{{ slider.value }}</span>
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SliderTypeComponent extends FieldType<FieldTypeConfig> {}

/**  Copyright 2021 Formly. All Rights Reserved.
    Use of this source code is governed by an MIT-style license that
    can be found in the LICENSE file at https://github.com/ngx-formly/ngx-formly/blob/main/LICENSE */
